import React from 'react'
import PropTypes from 'prop-types'

import { Item, Button, Label, Icon } from 'semantic-ui-react'

class PhoneItem extends React.Component {

  render() {
    const { phone, selected, onClick } = this.props

    return (
      <Item>
        <Item.Content>
          <Item.Header>{phone}</Item.Header>
          <Item.Extra>
            {
              selected ?
              <Button
                color="teal"
                size='mini'
                floated="right"
                onClick={onClick}>
                <Icon name='globe' />
                Viendo
              </Button>
              :
              <Button
                size='mini'
                floated="right"
                onClick={onClick}>
                Ver Ubicaciones
                <Icon name='right chevron' />
              </Button>
            }
          </Item.Extra>
        </Item.Content>
      </Item>
    )
  }

  static propTypes = {
    phone: PropTypes.string.isRequired,
    selected: PropTypes.bool,
    onClick: PropTypes.func,
  }
}

export default PhoneItem;



// WEBPACK FOOTER //
// ./src/components/Phone/PhoneItem.js